import React from "react";
import { Form, Space, Typography } from "antd";
import ButtonComponent from "../Button/Button";
import IntegerInput from "../IntergerInput";

import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import "../../styles/_common.scss";

const { Text, Link } = Typography;


const VerifyOtp = ({ ...props }) => {

    return (
        <Space direction="vertical" size="middle" className="verify-otp-container" style={{ width: "100%" }}>
            <Text type="secondary" className="header-component__subtitle">
                A six digit OTP was sent to <Text strong>{props.email}</Text>
            </Text>
            <Text type="secondary" className="header-component__subtitle">
                Please enter it below to continue.
            </Text>
            <Form
                layout="vertical"
                className="form-new inputBoxStyle" 
                onFinish={props.onFinish}
            >

                <Form.Item
                className="mb5"
                    label={<span style={{fontSize: "14px"}}>Enter OTP</span>}
                    name="otp"
                    rules={[{ required: true, message: "OTP is required" },
                    {
                        pattern: /^\d{6}$/,
                        message: "OTP must be a 6-digit number",
                    },
                    ]}
                >
                    <IntegerInput
                        maxLength={6}
                        placeholder="Enter 6-digit OTP"
                        autoComplete="one-time-code"
                        style={{ textAlign: "center" }}
                    />
                </Form.Item>
                     {props.timer > 0 ? (
                <Text className="resendOtp" type="">
                    Please wait 120 seconds before resending a new OTP: {props.timer > 0 ? `in ${props.timer}s` : '00:00'}
                </Text>) : (
                <Text className="resendOtp" type="secondary">
                    Didn't receive the OTP ?{' '}
                    <Link onClick={props.handleResendOtp} disabled={props.timer > 0}>
                        Resend OTP {props.timer > 0 ? `in ${props.timer}s` : ''}
                    </Link>
                </Text>)}
                {/* OTP Input Fields can be added here */}
                <Form.Item>
                    <ButtonComponent
                        text={"Verify OTP"}
                        htmlType="submit"
                        className="login-card-new__button"
                        loading={props.loading}
                        icon={<RightOutlined />}
                    />
                </Form.Item>
            </Form>
           <div className="go-back-link">
            <Link className="go-back-link-label verify-otp-no-underline" onClick={props.onBack}><LeftOutlined /> Go Back</Link>
           </div>
        </Space>
    )
}

export default VerifyOtp;